var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tal_c",attrs:{"id":"public_loading"}},[_c('p',[_vm._v("\n    "+_vm._s(_vm.$t("msg.loading"))+" \n    "),_c('span',{staticClass:"public_loading_1"},[_vm._v(".")]),_vm._v(" "),_c('span',{staticClass:"public_loading_2"},[_vm._v(".")]),_vm._v(" "),_c('span',{staticClass:"public_loading_3"},[_vm._v(".")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7cf883d9","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/public/BaseLoading.vue
// module id = 734
// module chunks = 2